import {
  CalendarDateTime,
  getLocalTimeZone,
  toZoned,
} from "@internationalized/date";
import { format } from "date-fns";

export const ddMMyy = (calendarDateTime: CalendarDateTime) => {
  const date = calendarDateTime.toDate(getLocalTimeZone());
  return format(date, "dd.MM.yy");
};

export const calendarDateTimeToDate = (date: CalendarDateTime) =>
  toZoned(date, getLocalTimeZone()).toDate();

/**
 * Checks if `a` is atleast `offsetMs` before `b`.
 */
export const isBeforeDate = (a: Date, b: Date, offsetMs: number = 0) =>
  b.getTime() - a.getTime() >= offsetMs;
